import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { Row, Col, Input, Button, FormFeedback, FormText } from "reactstrap";

import getQueryString from "../../helpers/getQueryString";
import userActions from "../../actions/userActions";

const PasswordResetForm = () => {
  const query = getQueryString();
  const dispatch = useDispatch();

  const { register, handleSubmit, errors } = useForm();
  const [formState, setFormState] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    token: query.get("token"),
    submitted: false,
  });

  const onChange = (evt) => {
    const { target } = evt;
    if (target) setFormState({ ...formState, [target.name]: target.value });
  };

  const onSubmit = (data) => {
    if (
      formState.password === formState.confirmPassword &&
      formState.email !== ""
    ) {
      setFormState({ ...formState, submitted: true });
      dispatch(userActions.passwordReset(formState));
    }

    return;
  };

  return (
    <Row className="pr-0 pl-0 psInfo">
      <Col>
        <form onSubmit={handleSubmit(onSubmit)}>
          <h2 className="text-center text-uppercase">Password Reset</h2>
          <hr />
          <Row className="padTop">
            <Col md={6}>
              <h4 className="text-uppercase">password requirements</h4>
              <Row>
                <Col>
                  <span>
                    Passwords must contain an uppercase character, lowercase
                    character, a digit, and a non-alphanumeric character and at
                    least six characters long.
                  </span>
                </Col>
              </Row>
            </Col>
            <Col md={6}>
              <br className="d-md-none" />
              <h4 className="text-uppercase">Reset Password</h4>
              <Row>
                <Col>
                  <Input
                    type="hidden"
                    name="token"
                    value={query.get("token")}
                  />
                  <Input
                    type="password"
                    name="password"
                    placeholder="New password"
                    value={formState.password}
                    style={{ width: "90%" }}
                    onChange={(evt) => onChange(evt)}
                    innerRef={register({
                      required: true,
                      min: 6,
                      pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{6,})/,
                    })}
                    invalid={errors.password ? true : false}
                  />
                  <FormText>
                    Passwords must contain an uppercase character, lowercase
                    character, a digit, and a non-alphanumeric character and at
                    least six characters long.
                  </FormText>
                  {errors.password && (
                    <FormFeedback>
                      Your password does not meet the minimum requirements.
                    </FormFeedback>
                  )}
                </Col>
                <Col>
                  <Input
                    type="password"
                    name="confirmPassword"
                    placeholder="Confirm new password"
                    value={formState.confirmPassword}
                    style={{ width: "90%" }}
                    onChange={(evt) => onChange(evt)}
                    innerRef={register({
                      required: true,
                      min: 6,
                      pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{6,})/,
                    })}
                    invalid={errors.confirmPassword ? true : false}
                  />
                  <FormText>
                    Passwords must contain an uppercase character, lowercase
                    character, a digit, and a non-alphanumeric character and at
                    least six characters long.
                  </FormText>
                  {errors.confirmPassword && (
                    <FormFeedback>
                      Your password does not meet the minimum requirements.
                    </FormFeedback>
                  )}
                </Col>
              </Row>
              <Row className="padTop">
                <Col>
                  <Input
                    type="email"
                    name="email"
                    placeholder="E-mail"
                    value={formState.email}
                    onChange={(evt) => onChange(evt)}
                    innerRef={register({
                      required: true,
                      min: 6,
                      pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                      //pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                    })}
                    invalid={errors.email ? true : false}
                  />
                  <FormText>Enter your email example@example.gov.</FormText>
                  {errors.email && (
                    <FormFeedback>Your email is not valid.</FormFeedback>
                  )}
                </Col>
                <Col>
                  <Button className="bgBlue" style={{ width: "100%" }}>
                    Reset password
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </form>
      </Col>
    </Row>
  );
};

export default PasswordResetForm;
